/** @jsxImportSource @emotion/react */
import React from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { getTakerTokens } from "../../../store/global/selectors";
import { useTokenListByChain } from "hooks/useTokenListByChain";
import { Text } from "../../../components/general/Text";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { getNameForToken } from "../../../utils/tokenListUtils";
import { getTokenTicker } from "../../../utils/tokenUtils";

export const YouPaySection: React.FC = () => {
  const takerTokens = GlobalStore.useState(getTakerTokens);
  const tokenList = useTokenListByChain();
  const quote = GlobalStore.useState(s => s.quote);
  const wrapQuote = GlobalStore.useState(s => s.wrapQuote);
  const theme = GlobalStore.useState(s => s.theme);

  if (!quote && !wrapQuote) {
    return null;
  }

  return (
    <YouPaySectionContainer>
      <YouPayContent>
        <YouPaidContainer>
          <Text textStyle="Title" size="Small" color={theme.surface.main.secondary.default}>
            You paid
          </Text>
          <TokenRowContainer direction="column">
            {takerTokens.map(token => {
              const tokenName = getNameForToken(token.tokenAddress, tokenList);
              return (
                <TokenRow key={token.tokenAddress}>
                  <div
                    key={token.tokenAddress}
                    css={css`
                      display: flex;
                      gap: 4px;
                    `}
                  >
                    <Text
                      textStyle="Title"
                      size="XS"
                      color={theme.surface.main.secondary.default}
                      textCss={css`
                        display: flex;
                        align-items: center;
                        gap: 4px;
                      `}
                    >
                      <img
                        src={tokenList ? tokenList[token.tokenAddress]?.iconUrl : ""}
                        alt={"Pay token"}
                        width={16}
                        height={16}
                      />{" "}
                      {getTokenTicker(token.tokenAddress, tokenList)}
                    </Text>
                    <Text
                      textStyle="Paragraph"
                      size="Large"
                      color={theme.surface.main.secondary.default}
                    >
                      {tokenName === "" ? getTokenTicker(token.tokenAddress, tokenList) : tokenName}
                    </Text>
                  </div>
                  <Text textStyle="Title" size="XS" color={theme.surface.main.secondary.default}>
                    {token.amount.toDisplay(token.tokenAddress, tokenList)}
                  </Text>
                </TokenRow>
              );
            })}
          </TokenRowContainer>
        </YouPaidContainer>
        <TokenRowContainer direction="row">
          <Text textStyle="Title" size="XS" color={theme.surface.main.secondary.default}>
            Slippage
          </Text>
          <Text textStyle="Title" size="XS" color={theme.surface.main.secondary.default}>
            0% on Bebop
          </Text>
        </TokenRowContainer>
      </YouPayContent>
    </YouPaySectionContainer>
  );
};

const YouPaySectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

const YouPayContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 26px;
  gap: 28px;
  align-self: stretch;
`;

const YouPaidContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 13px;
  align-self: stretch;
`;

const TokenRowContainer = styled.div<{ direction: "column" | "row" }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  flex-direction: ${props => props.direction};
  gap: 13px;
`;

const TokenRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
`;
